import { ModuleWithProviders, NgModule } from '@angular/core';
import { AuthStore } from '@lemsar/storage/stores/auth.store';
import { GlobalStoreService } from '@lemsar/storage/services/global-store.service';
import { UbudStorageModule } from '@ubud/storage';

const STORES = [AuthStore];

@NgModule({
    imports: [UbudStorageModule.forRoot()],
})
export class LemsarStorageModule {
    public static forRoot(): ModuleWithProviders {
        return {
            ngModule: LemsarStorageModule,
            providers: [GlobalStoreService, ...STORES],
        };
    }
}



// WEBPACK FOOTER //
// ./src/lemsar/storage/storage.module.ts